import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import axios from "axios";
import Message from "../../Components/Message";
import apiClient from "../../AppClient";
import { useParams } from "react-router-dom";
const CustomerModal = ({
  show,
  handleClose,
  mode,
  CustomerData,
  refreshData,
}) => {
  const { id } = useParams();
  const [error, setError] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    customer_type_id: "",
  });
  const [customertpe, setCustomertype] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (CustomerData) {
      setFormData(CustomerData);
    } else {
      setFormData({ name: "", phone: "" });
    }
  }, [CustomerData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  useEffect(() => {
    const fetchCustomerTypes = async () => {
      setLoading(true);
      apiClient
        .get("/customertypes/")
        .then((response) => {
          setCustomertype(response.data);
          setLoading(false);
          setError(null);
        })
        .catch((error) => {
          if (error.response) {
            setError(error.response.data.detail);
            setLoading(false);
          } else {
            setError("حدث خطأ أثناء الاتصال بالسيرفر");
            setLoading(false);
          }
        });
    };
    fetchCustomerTypes();
  }, []);

  const handleAddCustomer = async () => {
    setLoading(true);
    apiClient
      .post("/customers/add/", formData)
      .then((response) => {
        alert("تمت الإضافة بنجاح!");
        refreshData();
        handleClose();
        setError(null);
      })
      .catch((error) => {
        if (error.response) {
          setError(error.response.data.detail);
          setLoading(false);
        } else {
          setError("حدث خطأ أثناء الاتصال بالسيرفر");
          setLoading(false);
        }
      });
    setLoading(false);
  };

  const handleUpdateCustomer = async () => {
    setLoading(true);
    apiClient
      .put(`/customers/${CustomerData.id}/update/`, formData)
      .then((response) => {
        alert("تم التعديل بنجاح!");
        refreshData();
        handleClose();
        setError(null);
      })
      .catch((error) => {
        if (error.response) {
          setError(error.response.data.detail);
          setLoading(false);
        } else {
          setError("حدث خطأ أثناء الاتصال بالسيرفر");
          setLoading(false);
        }
      });
    setLoading(false);
  };

  const handleSubmit = () => {
    if (mode === "add") {
      handleAddCustomer();
    } else {
      handleUpdateCustomer();
    }
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header className="modal-container flex-column-reverse" closeButton>
        {error && <Message variant="danger">{error} </Message>}
        <Modal.Title>
          {mode === "add" ? "إضافة زبون جديد" : "تعديل الزبون"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="CustomerName">
            <Form.Label>اسم الزبون</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="أدخل اسم الزبون"
            />
          </Form.Group>
          <Form.Group controlId="CustomerPhone">
            <Form.Label>رقم الهاتف</Form.Label>
            <Form.Control
              type="text"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="أدخل رقم الهاتف"
            />
          </Form.Group>
          <Form.Group controlId="CustomerType">
            <Form.Label>نوع الزبون</Form.Label>
            <Form.Control
              as="select"
              name="customer_type_id"
              value={formData.customer_type_id}
              onChange={handleChange}
            >
              <option value="">اختر نوع الزبون</option>
              {customertpe.map((type) => (
                <option key={type.id} value={type.id}>
                  {type.name}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleSubmit}>
          {mode === "add" ? "إضافة" : "تعديل"}
        </Button>
        <Button variant="secondary" onClick={handleClose}>
          إلغاء
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CustomerModal;
